import React from 'react';

export const RowActionDescriptionV2 = ({ workflow }) => {
  return (
    <div className={'w-full max-h-40 overflow-auto flex flex-row items-start gap-4 relative px-3'}>
      <div>
        <p className={'text-sm'}>
          <span className={'font-medium text-grey_750 whitespace-break-spaces'}>
            {workflow.trigger_value}
          </span>
        </p>
      </div>
    </div>
  );
};
